// extracted by mini-css-extract-plugin
export default {"section":"paymentmethod_section__+5a5m","sectionHeading":"paymentmethod_sectionHeading__Htg1m","table":"paymentmethod_table__e9t7q"};